import React from 'react';
import { Stack } from '@mantine/core';
import { BlockImageField } from '../../../puck/fields/puckImageField';
import { PxSpacingInput } from '../../../puck/fields/puckPxSpacingField';
import { useSelectedItemProps } from '../../../puck/fields/useSelectedItemProps';

/**
 * Logo de l'entreprise citée : fichier + hauteur, dans la même section de
 * champ Puck. Le champ édite `logoUrl` ; `logoHeight` est écrite via dispatch
 * (le onChange d'un champ ne couvre que sa prop) — pattern
 * InfoCardIllustrationField.
 */
export default function InfoCardLogoField({ value, onChange }) {
  const { itemProps, updateItemProps } = useSelectedItemProps();

  return (
    <Stack gap={12}>
      <BlockImageField
        name="logoUrl"
        value={value ?? ''}
        onChange={(next) => onChange(next ?? '')}
        label="Logo de l'entreprise"
      />
      {value ? (
        <PxSpacingInput
          label="Hauteur du logo"
          value={itemProps.logoHeight ?? ''}
          onChange={(next) => updateItemProps({ logoHeight: next })}
        />
      ) : null}
    </Stack>
  );
}
